{
  AOS.init();
}
{
  document.querySelectorAll(".products_wrprs").forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll(".product_Tabs ul li");
    const rows = wrapper.querySelectorAll(".products_ROWS");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        // Remove active from all content rows
        rows.forEach((r) => r.classList.remove("active"));
        // Add active to corresponding row
        rows[index].classList.add("active");
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray(".anim-Y-img").forEach((element) => {
      gsap.fromTo(
        element,
        { scale: 1.5 },
        {
          scale: 1,
          ease: "none",
          scrollTrigger: {
            trigger: element,
            start: "top 90%",
            end: "top 30%",
            scrub: 1,
          },
        }
      );
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", () => {
    const allTabs = document.querySelectorAll(".products_tabs");
    allTabs.forEach((tabsContainer) => {
      const tabButtons = tabsContainer.querySelectorAll(
        ".products_tabs_menu li"
      );
      const tabContents = tabsContainer.querySelectorAll(".tab__prnt");
      tabButtons.forEach((btn, index) => {
        btn.addEventListener("click", () => {
          tabButtons.forEach((b) => b.classList.remove("isActive"));
          tabContents.forEach((c) => c.classList.remove("isActive"));
          btn.classList.add("isActive");
          tabContents[index].classList.add("isActive");
        });
      });
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  const firevideo = document.querySelector(".fire_video");
  if (firevideo) {
    firevideo.style.display = "block";
  }
});

// document.querySelectorAll('[data-handle="select-size"] label').forEach(label => {
//   if (label.innerText.trim().includes("Order a sample")) {
//     label.classList.add("sample-label");
//   }
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const header = document.querySelector("theme-header");

//   window.addEventListener("scroll", () => {
//     if (window.scrollY > 100) {
//       header.classList.add("is-sticky");
//     } else {
//       header.classList.remove("is-sticky");
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("theme-header");
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    let currentScroll = window.scrollY;

    if (currentScroll > 0) {
      if (currentScroll > lastScroll) {
        header.classList.remove("show-header");
        header.classList.add("hide-header");
      } else {
        header.classList.remove("hide-header");
        header.classList.add("show-header");
      }
    } else {
      header.classList.remove("hide-header");
      header.classList.remove("show-header");
    }

    lastScroll = currentScroll;
  });
});
{
//   document.addEventListener("DOMContentLoaded", function () {
//   const quantitySelectors = document.querySelectorAll(".quantity");

//   quantitySelectors.forEach((selector) => {
//     const minusBtn = selector.querySelector(".minus");
//     const plusBtn = selector.querySelector(".plus");
//     const qtyInput = selector.querySelector(".qty");
//     const amountEl = document.querySelector(".amount"); // price element

//     if (!amountEl) return; // agar price element nahi hai, toh kuch mat karo

//     // Original price store karo
//     const basePrice = parseFloat(amountEl.textContent.replace(/[^\d.]/g, ""));

//     // Update amount function
//     function updateAmount() {
//       const quantity = parseInt(qtyInput.value);
//       const newTotal = basePrice * quantity;
//       amountEl.textContent = `${newTotal.toFixed(2)} AED`; // update text
//     }

//     // Plus button click
//     plusBtn.addEventListener("click", function () {
//       qtyInput.value = parseInt(qtyInput.value) + 1;
//       updateAmount();
//     });

//     // Minus button click
//     minusBtn.addEventListener("click", function () {
//       let currentVal = parseInt(qtyInput.value);
//       if (currentVal > 1) {
//         qtyInput.value = currentVal - 1;
//         updateAmount();
//       }
//     });
//   });
// });

}

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".banner_media video");
  videos.forEach(video => {
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("x5-playsinline", "");
    video.muted = true;
    video.play().catch(() => {
      console.log("Autoplay blocked on iOS Safari");
    });
  });
});
{
  document.addEventListener("DOMContentLoaded", () => {
    const mainBtns = document.querySelectorAll(".newsLatrActive");
    const popups = document.querySelectorAll(".popup_wrper");

    mainBtns.forEach((btn, index) => {
      const currentPopup = popups[index];
      const popupInner = currentPopup.querySelector(".Newslatter_popup__row");
      const closeBtn = currentPopup.querySelector(".closed_popup");

      // Open popup
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        currentPopup.classList.add("active");
      });

      // Close popup on close button
      closeBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        currentPopup.classList.remove("active");
      });

      // Click outside inner box → close
      currentPopup.addEventListener("click", (e) => {
        if (!popupInner.contains(e.target)) {
          currentPopup.classList.remove("active");
        }
      });

      // Stop click inside popup from bubbling (so it doesn’t close)
      popupInner.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  });
}
